import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';

import './FooterComponent.scss';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';

export default function FooterComponent() {
    return (
        <section className='footer'>
            <img alt='Kakariki Coffee' className='tw-h-[90px]' src='/images/banner/kakariki-logo.png' />
            <p className='tw-px-16 md:tw-px-0 footer-cafe-name tw-uppercase tw-text-center tw-my-[20px]'>Kakariki Coffee</p>
            <div className='address-bar tw-pb-16 tw-flex tw-justify-center'>
                <p className='md:tw-w-1/4'>Kakariki Coffee, 10 Customhouse Quay, Wellington Central, Wellington 6011, <br></br>New Zealand</p>
            </div>
            <div className='social-media tw-pb-16 tw-flex tw-justify-center'>
                <div className='tw-w-1/4 '>
                    <div class="flex justify-center gap-8">
                        <a href="tel:+64220134354">
                            <FontAwesomeIcon icon={faPhone} />
                        </a>
                        <a href="https://www.instagram.com/kakarikicoffee/" target='_blank'>
                            <FontAwesomeIcon icon={faInstagram} />
                        </a>
                        <a href='https://www.facebook.com/p/Kakariki-Coffee-100085452117231/' target='_blank'>
                            <FontAwesomeIcon icon={faFacebookF} />
                        </a>
                        {/* <a href='https://wa.me/+64220134354' target='_blank'>
                            <FontAwesomeIcon icon={faWhatsapp} />
                        </a> */}
                        <a href='mailto:kakarikicoffee@gmail.com'>
                            <FontAwesomeIcon icon={faEnvelope} />
                        </a>
                    </div>
                </div>
            </div>

        </section>
    );
}